let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("epSJY")).then(() => parcelRequire('2iK9l'));